import { AulaEntities } from '../Entities';
import { AulaEditorContext, AulaEditorInstance, AulaElement } from '../types';

export const handleCutCopy = (
  event: React.ClipboardEvent,
  editor: AulaEditorInstance,
  context: AulaEditorContext,
) => {
  const fragment = editor.getFragment() as AulaElement[];
  const selectedEntities = {} as AulaEntities;
  for (const element of fragment) {
    if (element.entity) {
      selectedEntities[element.entity] = context.entities[element.entity];
    }
  }
  event.clipboardData.setData(
    'application/json',
    JSON.stringify(selectedEntities),
  );
};
